/*----- Core -----*/
import React 			from 'react'
import styled, { css } from 'styled-components'
import PropTypes 	from 'prop-types'

/*----- Styles -----*/
const StyledVideo = styled.div`
  height: 250px;
  max-height: auto;
  position: relative;
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  video {
    position: absolute;
    z-index: 1;
    min-width: 100%;
    min-height: 100%;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-width: inherit;
  }
  .video-container {
	  position: absolute;
	  width: 100%;
	  height: 100%;
	  top: 0;
	  left: 0;
  }
	.video-container__cover {
		z-index: 2;
		position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
		${props => props.coverColor && css`
			background-color: ${props.coverColor};
		`}
	}
`

/*----- Export -----*/
const Video = ({ height, width, videoUrl, coverColor }) => (
  <StyledVideo style={{ height: height, width: width }} coverColor={coverColor} className="video-container">
		<div className="video-container__cover"></div>
    <video preload="true" autoPlay="autoplay" loop="loop" muted="muted">
      <source src={ videoUrl } type="video/mp4"></source>
    </video>
  </StyledVideo>
)
export default Video
/*----- PropTypes -----*/
Video.propTypes = {
  height:			PropTypes.number,
  width:  		PropTypes.number,
  videoUrl: 	PropTypes.string.isRequired,
  coverColor: PropTypes.string
}
